@if (transaction.type !== PaymentType.REFUND && transaction.refunds?.length > 0) {
  <ap-panel *apSecure='[Permissions.ACCESS_ALL_PAYMENTS]'>
    <ap-panel-content>
      <div class='form-horizontal form-label-left'>
        <div class='row refunds-details-container'>
          <div class='col-sm-12 col-md-12 col-xs-12'>
            <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.TITLE' | translate }}</span>
            <div class='table-responsive refunds-array'>
              <table mat-table #refundsTable [dataSource]='transaction.refunds' id='datatable' class='table table-hover table-bordered table-fixed no-footer' role='grid' aria-describedby='datatable_info'>
                <!-- REFUND REFERENCE -->
                <ng-container matColumnDef='{{ refundColumns[0] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.' + refundColumns[0] | translate }}</th>
                  <td mat-cell *matCellDef='let refund'>{{ refund.reference | noData }}</td>
                  <td mat-footer-cell *matFooterCellDef [attr.colspan]='2'></td>
                </ng-container>
                <!-- REFUND DATE -->
                <ng-container matColumnDef='{{ refundColumns[1] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.' + refundColumns[1] | translate }}</th>
                  <td mat-cell *matCellDef='let refund'>{{ refund.creationDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <!-- REFUND PAYMENTMEAN -->
                <ng-container matColumnDef='{{ refundColumns[2] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.' + refundColumns[2] | translate }}</th>
                  <td mat-cell *matCellDef='let refund'>{{ ('STATUS.TRANSACTIONS.PAYMENTMEAN_TYPE.' + refund.paymentMeanType | translate) + (refund.paymentMeanLabel ?  ' ' + refund.paymentMeanLabel : '') }}</td>
                  <td mat-footer-cell *matFooterCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.FOOTER.TOTAL' | translate }}</td>
                </ng-container>
                <!-- REFUND TOTAL AMOUNT -->
                <ng-container matColumnDef='{{ refundColumns[3] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.' + refundColumns[3] | translate }}</th>
                  <td mat-cell *matCellDef='let refund'>{{ refund.amount | apCurrency | noData }}</td>
                  <td mat-footer-cell *matFooterCellDef>{{ transaction.amountRefunded | apCurrency | noData }}</td>
                </ng-container>
                <!-- REFUND STATUS -->
                <ng-container matColumnDef='{{ refundColumns[4] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.' + refundColumns[4] | translate }}</th>
                  <td mat-cell *matCellDef='let refund'>
                    @if (refund.status === PaymentStatus.PENDING) {
                      <status-label type='TRANSACTIONS.STATUS' [status]='refund.status' hasTooltip='true' tooltipContent="{{ 'TRANSACTIONS.LIST.TOOLTIP.STATUS_PENDING' | translate }}"></status-label>
                    } @else {
                      <status-label type='TRANSACTIONS.STATUS' [status]='refund.status'></status-label>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <!-- ACTIONS -->
                <ng-container matColumnDef='{{ refundColumns[5] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.REFUNDS.REFUND_LIST.COLUMNS.' + refundColumns[5] | translate }}</th>
                  <td mat-cell *matCellDef='let refund'><button (click)='navigateToTransactionDetails(refund.paymentId)' class='btn btn-xs btn-default'>{{ 'TRANSACTIONS.LIST.BUTTONS.DETAILS' | translate }}</button></td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef='refundColumns'></tr>
                <tr mat-row *matRowDef='let row; columns: refundColumns;' role='row' class='odd'></tr>
                <tr mat-footer-row *matFooterRowDef="footerRefundColumns"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </ap-panel-content>
  </ap-panel>
}
